import { Radio } from "@patternfly/react-core";
import { useTranslation } from "react-i18next";

type SexRadioGroupProps = {
  value: string;
  onChange: (value: string) => void;
};

export const SexRadioGroup = ({ value, onChange }: SexRadioGroupProps) => {
  const { t } = useTranslation();

  return (
    <div className="pf-l-flex">
      <Radio
        id="sex-male"
        name="sex"
        label={t("男性")}
        value="0"
        isChecked={value === "0"}
        onChange={() => onChange("0")}
      />

      <Radio
        id="sex-female"
        name="sex"
        label={t("女性")}
        value="1"
        isChecked={value === "1"}
        onChange={() => onChange("1")}
      />

      <Radio
        id="sex-other"
        name="sex"
        label={t("その他")}
        value="9"
        isChecked={value === "9"}
        onChange={() => onChange("9")}
      />
    </div>
  );
};